import { render, staticRenderFns } from "./totalview.vue?vue&type=template&id=6af77457&scoped=true"
import script from "./totalview.vue?vue&type=script&lang=js"
export * from "./totalview.vue?vue&type=script&lang=js"
import style0 from "./totalview.vue?vue&type=style&index=0&id=6af77457&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af77457",
  null
  
)

export default component.exports